import styled from "styled-components";
import { AccordionBody } from "../../../components/utilities";

const TableAccordionBody = styled(AccordionBody)`
    padding-top: 0 !important;
`;

export default TableAccordionBody;